abstract class BaseBuilder<T> {
  public abstract build(): T;
}

export default BaseBuilder;
